var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMic = function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5C9.33696 2.5 8.70107 2.72576 8.23223 3.12763C7.76339 3.52949 7.5 4.07454 7.5 4.64286V10.3571C7.5 10.9255 7.76339 11.4705 8.23223 11.8724C8.70107 12.2742 9.33696 12.5 10 12.5C10.663 12.5 11.2989 12.2742 11.7678 11.8724C12.2366 11.4705 12.5 10.9255 12.5 10.3571V4.64286C12.5 4.07454 12.2366 3.52949 11.7678 3.12763C11.2989 2.72576 10.663 2.5 10 2.5Z",
    stroke: "#2E3330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.33333V9.81481C15 11.19 14.4732 12.5089 13.5355 13.4813C12.5979 14.4537 11.3261 15 10 15C8.67392 15 7.40215 14.4537 6.46447 13.4813C5.52678 12.5089 5 11.19 5 9.81481V8.33333",
    stroke: "#2E3330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15V17.5",
    stroke: "#2E3330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.5H12.5",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgMic;